@if (currentTask) {
    <div class="ws-section__header__actions__item">
        <div class="ws-flex-container-horizontal">
            <div class="action-button-wrapper"
                 helpTooltip
                 [tooltipText]="currentTaskTooltip"
                 position="bottom">
                <button type="button"
                        class="ace-btn btn-primary btn-sm"
                        [disabled]="(!canEnterEditMode) || (!canEdit)"
                        (click)="completeCurrentTask()">
                    {{ currentTask.title }}
                </button>
            </div>
        </div>
    </div>
}
